import { render, staticRenderFns } from "./ModifyCalendarGroup.vue?vue&type=template&id=67a98042&scoped=true"
import script from "./ModifyCalendarGroup.vue?vue&type=script&lang=js"
export * from "./ModifyCalendarGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a98042",
  null
  
)

export default component.exports